export default __webpack_public_path__ + "static/media/darkHardBrake.a8845d0c.png";